import React, { useCallback } from 'react'
import { CpPlusSymbolGreen } from '@usap/uicomponents'
import {
  Container, Title, TextBody, LearnMore,
} from './style/CartSummaryBanner.css'

type BannerContentProps = {
  title: string
  body: string
}

type StaticProps = {
  cta: string
  notMemberFreeShippingForMembers: BannerContentProps
  notMemberFreeShippingForAll: BannerContentProps
  memberFreeShippingForMembers: BannerContentProps
}

type CartSummaryBannerProps = {
  hasActiveMembership: boolean
  hasFreeShippingForMembers: boolean
  hasFreeShipping: boolean
  GTM: any
  staticProps: StaticProps
}

type LearnMoreProps = {
  onClick: () => void
  cta: string
}

const LearnMoreButton: React.FC<LearnMoreProps> = ({ cta, onClick }) => (
  <a href="/membership" target="_blank" onClick={onClick}>
    <LearnMore>{cta}</LearnMore>
  </a>
)

type RootBannerProps = Omit<CartSummaryBannerProps, 'GTM'> & {
  staticProps: StaticProps,
  onClick: () => void
}

const Banner: React.FC<RootBannerProps> = ({
  hasActiveMembership, hasFreeShippingForMembers, hasFreeShipping, staticProps, onClick,
}) => {
  // https://usautoparts.atlassian.net/browse/PPP-1548
  const onlyFreeShippingForMembers = hasFreeShippingForMembers && !hasFreeShipping
  const { cta } = staticProps

  // ac#3, ac#4
  let { title, body } = staticProps.notMemberFreeShippingForMembers

  if (hasActiveMembership) {
    // ac#5, ac#6
    title = staticProps.memberFreeShippingForMembers.title
    body = staticProps.memberFreeShippingForMembers.body
  } else if (onlyFreeShippingForMembers) {
    // ac#2
    title = staticProps.notMemberFreeShippingForMembers.title
    body = staticProps.notMemberFreeShippingForMembers.body
  }

  return (
    <div>
      <Title>{title}</Title>
      <TextBody>{body}</TextBody>
      <LearnMoreButton cta={cta} onClick={onClick} />
    </div>
  )
}

// eslint-disable-next-line import/prefer-default-export
export const CartSummaryBanner: React.FC<CartSummaryBannerProps> = ({
  hasActiveMembership, hasFreeShippingForMembers, staticProps, hasFreeShipping, GTM,
}) => {
  const onClick = useCallback(() => {
    GTM?.membershipCartAboveOrderSummaryBannerLearnMoreEngaged()
  }, [GTM])
  return (
    <Container>
      <div>
        <CpPlusSymbolGreen width="32px" height="36px" />
      </div>
      <Banner
        hasActiveMembership={hasActiveMembership}
        hasFreeShippingForMembers={hasFreeShippingForMembers}
        hasFreeShipping={hasFreeShipping}
        staticProps={staticProps}
        onClick={onClick}
      />
    </Container>
  )
}
